import { FaIndent } from "react-icons/fa";
import { useGetEditor } from "../../../context/useEditorContext";
import { Seperator } from "./Seperator";
import { TopButton } from "./TopButton";
import { IconsContainer } from "./IconsContainer";

export function TextIndent() {
    const editor = useGetEditor().editor.current;

    function intentRight() {
        // @ts-ignore
        const { $from } = editor?.state.selection;

        for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            const typeName = node.type.name;

            console.log(typeName);

            if (typeName === "listItem") {
                return editor?.commands.sinkListItem("listItem");
            } else if (typeName === "taskItem") {
                return editor?.commands.sinkListItem("taskItem");
            }
        }
    }

    function intentLeft() {
        // @ts-ignore
        const { $from } = editor?.state.selection;

        for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            const typeName = node.type.name;

            if (typeName === "listItem") {
                return editor?.commands.liftListItem("listItem");
            } else if (typeName === "taskItem") {
                return editor?.commands.liftListItem("taskItem");
            }
        }
    }

    return (
        <IconsContainer>
            {/* Indent */}
            <TopButton
                icon={<FaIndent size={16} className="rotate-180" />}
                onClick={(e) => {
                    editor?.commands.focus();
                    intentLeft();
                }}
                alt="Indent Left"
            />
            <TopButton
                icon={<FaIndent size={16} />}
                onClick={(e) => {
                    editor?.commands.focus();
                    intentRight();
                }}
                alt="Indent Right"
            />
            <Seperator />
        </IconsContainer>
    );
}
